import {IconButton} from "@nike/eds";
import React from "react";
import classNames from "classnames";
import './simple-pagination.scss';

type PaginationProps = {
    currentOffset: number;
    totalItems: number;
    pageSize: number;
    onPageChange: (page: number, offset: number) => void;
    className?: string;
    [key: string]: any;
};

export const SimplePagination = ({ currentOffset, totalItems, pageSize, onPageChange, className, ...rest }: PaginationProps) => {
    const currentPage = Math.floor(currentOffset / pageSize) + 1;
    const totalPages = Math.ceil(totalItems / pageSize);
    const lastItemOffset = Math.min(currentOffset + pageSize - 1, totalItems - 1);

    const handlePrevious = () => {
        if (currentPage > 1) {
            const newPage = currentPage - 1;
            const newOffset = (newPage - 1) * pageSize;
            onPageChange(newPage, newOffset);
        }
    };
    const handleNext = () => {
        if (currentPage < totalPages) {
            const newPage = currentPage + 1;
            const newOffset = (newPage - 1) * pageSize;
            onPageChange(newPage, newOffset);
        }
    };

    return (
        <div className={classNames('simplePaginationToolbar', className)} {...rest}>
            <IconButton
                className={'paginationControls'}
                icon='CaretLeft'
                variant='ghost'
                label='Previous page'
                onClick={() => handlePrevious()}
                disabled={currentOffset <= 0}
                disableRipple
            />
            <span>{totalItems === 0 ? '0' : currentOffset !== lastItemOffset ? `${currentOffset + 1} - ${lastItemOffset + 1}` : `${currentOffset + 1}`} of {totalItems}</span>
            <IconButton
                className={'paginationControls'}
                icon='CaretRight'
                label='Next page'
                variant='ghost'
                onClick={() => handleNext()}
                disabled={currentPage >= totalPages}
                disableRipple
            />
        </div>
    );
}